import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { scrollBarNoHeight, scrollBarStyling } from 'src/styles/styles';
import { flex } from 'src/styles/utils';

export const MainSubHeaderContainer = styled.div`
  ${flex('row', '', '')}
  color: ${colors.white};
  overflow-x: auto;
  white-space: nowrap;
  ${scrollBarStyling()};
  ${scrollBarNoHeight}
  height: 60px;
  padding: 20px 0;
`;

export const SubMainHeaderContainer = styled.div`
  margin-left: 4px;
  margin-right: 22px;
  display: inline-block;
  padding: 0 8px;
  ${ZeeFontRegular(14, 18)};
  ${MQ.MediaSm} {
    margin-left: 12px;
  }
`;
